import React, { useState } from "react";
// types
import { TMainPageLayoutV2 } from "../type";
// utilities
import { mainPageItemNameDescriptionLanguageVersion, metaDataLanguageVersion } from "@/utilities/LanguageVersionSelectorShortcut";
import { Link } from "react-router-dom";


const MNPG051 = (props: TMainPageLayoutV2) => {
    console.log("MNPG051.rendered", props);

    const [languageVersion] = useState(mainPageItemNameDescriptionLanguageVersion(props.template?.languageVersions));

    const [contactUs] = useState(props.templates?.find((item) => item.parentId === props.template?.id));
    const [address] = useState(metaDataLanguageVersion("address", contactUs?.languageVersions));
    const [mapURL] = useState(metaDataLanguageVersion("mapURL", contactUs?.languageVersions));
    const [phone] = useState(metaDataLanguageVersion("phone", contactUs?.languageVersions));
    const [email] = useState(metaDataLanguageVersion("email", contactUs?.languageVersions));
    const [workingHours] = useState(metaDataLanguageVersion("workingHours", contactUs?.languageVersions));

    if ( !props.template ) return null;

    return (
        <div className="offcanvas__contact">
            <h4>{languageVersion?.name}</h4>
            <ul>
                <li className="d-flex align-items-center">
                    <div className="offcanvas__contact-icon">
                        <i className="fal fa-map-marker-alt"></i>
                    </div>
                    <div className="offcanvas__contact-text">
                        <Link to={mapURL} aria-label="address">{address}</Link>
                    </div>
                </li>
                <li className="d-flex align-items-center">
                    <div className="offcanvas__contact-icon mr-15">
                        <i className="far fa-phone"></i>
                    </div>
                    <div className="offcanvas__contact-text">
                        <Link to={`tel:${phone?.trim()?.replace(/[^0-9]/g, "")}`} aria-label="phone">{phone}</Link>
                    </div>
                </li>
                <li className="d-flex align-items-center">
                    <div className="offcanvas__contact-icon mr-15">
                        <i className="fal fa-envelope"></i>
                    </div>
                    <div className="offcanvas__contact-text">
                        <Link to={`mailto:${email}`} aria-label="email">{email}</Link>
                    </div>
                </li>
                <li className="d-flex align-items-center">
                    <div className="offcanvas__contact-icon mr-15">
                        <i className="fal fa-clock"></i>
                    </div>
                    <div className="offcanvas__contact-text">
                        {workingHours}
                    </div>
                </li>
            </ul>
        </div>
    )
}

const Component = React.memo(MNPG051, (prevProps: TMainPageLayoutV2, nextProps: TMainPageLayoutV2) => {
    console.log("MNPG051.memo", { prevProps, nextProps });
    return true;
});

export default Component;
